import React, { useEffect, useState } from "react";
import BookedHotel from "./BookedHotel";
import DeleteButton from "../../../../components/admin/usable/actions/DeleteButton";
import { useSelector } from "react-redux";

const FloatingBookMenu = () => {
  const [isShow, setIsShow] = useState(false);
  const { bookedHotel, hotelinfo } = useSelector((state) => state.booked);
  const [shake, setShake] = useState(false);
  useEffect(() => {
    if (bookedHotel.length === 0) {
      setShake(false);
    }
    if (bookedHotel.length > 0) {
      setShake(true);

      const timer = setTimeout(() => {
        setShake(false);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [bookedHotel.length]);
  return (
    <>
      {isShow && (
        <div
          className="fixed inset-0 bg-black/50 flex justify-center items-center z-40"
          onClick={() => setIsShow(false)}
        >
          <div
            className="bg-white w-[90%] max-w-[350px] rounded-xl shadow-lg overflow-hidden relative"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="absolute top-2 right-2">
              <DeleteButton onClick={() => setIsShow(false)} />
            </div>

            <div className="max-h-[70vh] overflow-y-auto p-3">
              <BookedHotel />
            </div>
          </div>
        </div>
      )}

      <button
        onClick={() => setIsShow(true)}
        className="fixed bottom-20 left-1/2 -translate-x-1/2 z-30 lg:hidden"
      >
        <span
          className={`block bg-blue-800 text-white px-4 py-2 rounded-full text-xs shadow-md ${
            shake ? "animate-bounce" : ""
          }`}
        >
          {bookedHotel.length > 0
            ? `${bookedHotel.length} Room Added`
            : "Booked Nothing"}
        </span>
      </button>
    </>
  );
};

export default FloatingBookMenu;
